module.exports = __webpack_public_path__ + "img/shoushi01.01e880cf.png";